<ng-container *ngIf="title || body" [ngSwitch]="type">
  <ng-container *ngSwitchDefault>
    <div *ngIf="showTitle && title" class="content-title" [innerHTML]="title | safeHtml"></div>
    <div [innerHTML]="body | safeHtml" class="body" (delegateLinks)="onClick($event)"></div>
  </ng-container>
  <ion-label class="ion-text-wrap label" *ngSwitchCase="'label'" [innerHTML]="body | safeHtml"></ion-label>
</ng-container>
<div *ngIf="error" class="invalid-feedback">{{error}}</div>